import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import LandscapeBaseAddTemplate from '../../../templates/LandscapeBaseAddTemplate';
import { NotSavedInfoMolecule } from '../../molecules';

interface LandscapeNotSavedInfoTemplateProps {
  content: string;
}

const LandscapeNotSavedInfoTemplate: FC<LandscapeNotSavedInfoTemplateProps> = ({
  content,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseAddTemplate>
          <NotSavedInfoMolecule content={content} />
        </LandscapeBaseAddTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeNotSavedInfoTemplate;
